import React from 'react'
import moment from 'moment'
import {Mutation} from 'react-apollo'
import PropTypes from 'prop-types'
import {toast} from 'react-toastify'

import LoadingButton from "./LoadingButton";
import upsertProjectNotesMutation from '../../queries/server/mutations/upsert_project_notes'
import editProjectLocalMutation from '../../queries/client_side/mutations/edit_project'
import ProjectNoteCommentCreate from "./project/ProjectNoteCommentCreate";
import ProjectNoteCommentsList from "./project/ProjectNoteCommentsList";

const ProjectNotesListItem = (props) => {

    const {project_id, id, note, comments} = props

    return (
        <Mutation mutation={upsertProjectNotesMutation}>
            {(upsertProjectNotesMutationFunc, {loading}) => (
                <Mutation mutation={editProjectLocalMutation}>
                    {(editProjectLocalMutationFunc) => (
                        <div className="d-flex flex-column border-bottom p-2">
                            <div className="d-flex flex-row justify-content-between align-items-center">
                                <div className="d-flex flex-column align-items-start justify-content-center">
                                    <p className="font-weight-light p-0 m-0">{props.note}</p>
                                    <small
                                        className="text-muted">{moment(props.date_created).format('Do MMM YY')} - {props.user.full_name}</small>
                                </div>
                                <LoadingButton
                                    size="sm"
                                    color="danger"
                                    icon="trash-alt"
                                    loading={loading}
                                    onClick={() => {
                                        upsertProjectNotesMutationFunc({variables: {project_id, data: [{id, note, active: false}]}})
                                            .then(({data}) => {
                                                toast.success('Note Removed', {autoClose: 2000})
                                                editProjectLocalMutationFunc({variables: {data: data.upsertProjectNotes}})
                                            })
                                            .catch(e => toast.error(e.message, {autoClose: false}))
                                    }}
                                />
                            </div>
                            <ProjectNoteCommentCreate project_id={project_id} parentID={id}/>
                            <div className="d-flex" style={{flex: 1}}>
                                {comments && <ProjectNoteCommentsList project_id={project_id} notes={comments}/>}
                            </div>
                        </div>
                    )}
                </Mutation>
            )}

        </Mutation>

    )

}

ProjectNotesListItem.propTypes = {
    project_id: PropTypes.string.isRequired
}

export default ProjectNotesListItem